import React from "react";
import HeroSection from "./HeroSection";
import GlobalLeader from "./GlobalLeader";
import WeAre from "./WeAre";
import OfferSection from "./OfferSection";
import Carousel from "../cardCarousel/Carousel";
import Carousel1 from "../cardCarousel/Carousel1";

const BodySection = () => {
  return (
    <main className="w-full bg-slate-50/50 overflow-hidden min-h-screen flex flex-col relative">
      {/* Immersive Main Banner Entry Window */}
      <HeroSection />

      {/* Brand Purpose, Vision & Mission Overview */}
      <GlobalLeader />

      {/* Corporate Focus & Identity Presentation */}
      <WeAre />

      {/* Modernized Product & Application Overview */}
      <OfferSection />

      {/* Dynamic Product Showcase Carousel */}
      <Carousel />

      {/* ISO Quality & Accreditation Showcase Deck */}
      <Carousel1 />
    </main>
  );
};

export default BodySection;